export default "__VITE_ASSET__CaLCv9wj__"